import script from "./PageHeader2col.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeader2col.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__